import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const RangeInput = styled.input`
  -webkit-appearance: none;
  appearance: none;
  border: 1px solid white;
  width: 220px;

  &::-webkit-slider-runnable-track {
    width: 300px;
    height: 5px;
    border: none;
    border-radius: 3px;
    background-color: ${({ theme }) => theme.colors.yellow};
  }

  &::-ms-fill-lower {
    background-color: red;
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;

    cursor: pointer;
    height: 16px;
    width: 16px;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    background: #020202;
    margin-top: 8px;
    margin-left: 8px;
    transform: translateX(-50%) rotate(45deg);
  }
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 220px;

  output {
    margin-left: -30%;
  }
`;

export const InfinityIconContainer = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ValueDisplay = styled.div`
  font-size: 18px;
  margin-bottom: 10px;
`;
